import { apiClientAuth } from "../http/httpClient";


export function DebtApi(contentType = "application/json")
{
    const https = apiClientAuth(contentType);

    return {
        
       /**
        * POST /api/debts
        * @desc    Create a new debt record
        * @access  Public
        * @param   {string} type - Type of debt (3-100 chars) - required
        * @param   {string} description - Description of debt (10-2000 chars) - required
        * @param   {number} amount - Amount of debt (must be > 0) - required
        * @param   {string} phone - Phone number (10-20 chars) - required
        * @param   {string} cni - CNI/ID number (5-20 chars) - required
        * @param   {string} name - Debtor name (3-100 chars) - required
        * @param   {integer} userId - User ID who created debt (must be valid user) - required
        * @returns {Object} Success status with new debt data including auto-generated ref
        */
        insert : (debts) => https.post("/api/debts", debts), 

       /**
        * GET /api/debts
        * @desc    Retrieve all debt records
        * @access  Private (Admin)
        * @returns {Object} Array of all debts with user information sorted by createdAt DESC
        */
        findAll: () => https.get(`/api/debts`),

       /**
        * PUT /api/debts/:id
        * @desc    Update a debt record with amount history tracking
        * @access  Private (Admin)
        * @param   {integer} id - Debt ID - required
        * @param   {string} type - New type of debt (optional, 3-100 chars)
        * @param   {string} description - New description (optional, 10-2000 chars)
        * @param   {number} amount - New amount (optional, must be > 0) - old amount moved to oldAmount
        * @param   {string} phone - New phone number (optional, 10-20 chars)
        * @param   {string} cni - New CNI (optional, 5-20 chars)
        * @param   {string} name - New debtor name (optional, 3-100 chars)
        * @param   {string} status - New status (optional, pending/paid/canceled)
        * @returns {Object} Updated debt with old amount preserved in oldAmount field
        */
        update: (id, debts) => https.put(`/api/debts/${id}`, debts),

       /**
        * GET /api/debts/:id
        * @desc    Retrieve single debt record by ID
        * @access  Private (Admin)
        * @param   {integer} id - Debt ID - required
        * @returns {Object} Debt data with user information
        */
        findOne: (id) => https.get(`/api/debts/${id}`),

      };
}

